//   验证用户名  用户名要求 数字、字母
export function isvalidUsername(str) {
    const reg = /^[A-Za-z0-9]{4,16}$/;
    return reg.test(str);
}
//验证手机号
export function isvalidPhone(str) {
    const reg = /^[\s\S]*$/;
    return reg.test(str);
  }
// 验证密码 密码，字母数字，长度在6~16之间
export function isvalidPass(str) {
    const reg = /^[\da-zA-Z-_#%&*]{6,16}$/;
    return reg.test(str);
}
  //验证邮箱账号
export function isvalidEmail(str) {
  const reg = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/;
  return reg.test(str);
  }


// WEBPACK FOOTER //
// ./src/components/resgiter/reg/validation.js